import { apiClient } from "../../shared/api/clients";

// ── /users (page Utilisateurs) ───────────────────────────────────────────────

export interface ApiUser {
  userId?: string;
  id?: string;
  username?: string;
  fullName?: string;
  email?: string;
  phone?: string;
  idRole?: string | number;
  nom?: string; // libellé rôle
  isActive?: number | boolean;
  photoUrl?: string;
  depot?: string;
}

export interface ApiRole {
  id?: string | number;
  idRole?: string | number;
  nom?: string;
}

export interface ApiDepot {
  cod_dep?: string;
  adr_dep?: string;
}

export interface UsersDataResponse {
  success: boolean;
  message?: string;
  users?: ApiUser[];
  roles?: ApiRole[];
  depots?: ApiDepot[];
}

export interface ActionResponse {
  success: boolean;
  message?: string;
}

const enc = encodeURIComponent;

export const getUsersData = () =>
  apiClient.get<UsersDataResponse>("/users/data").then(({ data }) => data);

export const assignUserRole = (userId: string, roleId: string) =>
  apiClient
    .post<ActionResponse>("/users/assign-role", { userId, roleId })
    .then(({ data }) => data);

export const assignUserDepot = (userId: string, codDepot: string) =>
  apiClient
    .put<ActionResponse>(`/users/${enc(userId)}/depot`, { codDepot })
    .then(({ data }) => data);

export const setUserActive = (userId: string, active: boolean) =>
  apiClient
    .put<ActionResponse>(`/users/${enc(userId)}/${active ? "activate" : "deactivate"}`)
    .then(({ data }) => data);

// ── /attribution-roles ───────────────────────────────────────────────────────

export interface AttributionDataResponse<U, R> {
  success: boolean;
  message?: string;
  users?: U[];
  roles?: R[];
}

export const getAttributionData = <U, R>() =>
  apiClient
    .get<AttributionDataResponse<U, R>>("/attribution-roles/data")
    .then(({ data }) => data);

export const assignAttributionRole = (userId: string, roleId: string | undefined) =>
  apiClient
    .post<unknown>("/attribution-roles/assign", { userId, roleId })
    .then(({ data }) => data);
